import { styled } from '@mui/system';
import Typography, { TypographyProps } from '@mui/material/Typography';

const TypographyTitle = styled(Typography)<TypographyProps>(({ style }) => ({
    fontWeight: 700,
    ...style,
}));

export default TypographyTitle;
